module.exports = __webpack_public_path__ + "4f43a7ad2f3552db1a6a6ea3b1503999.jpg";